/**
 * @param  {string} htmlString
 */
module.exports = (htmlString) => {
  const box = document.createElement('div')
  box.innerHTML = htmlString
  return box.firstElementChild
}
